import React from "react";
import { statPrioColor } from "../TierLists/TierListHelper";
import { MediaQuery } from "@outplayed/responsive";
import { TooltipContainer } from "@outplayed/tooltips";
import { ReactComponent as TooltipIcon } from "svg/question-line.svg";
import { capitalizeFirstLetter } from "../../../lib/format_helper";
import { ReactComponent as ChevronLeft } from "svg/chevron-back.svg";
import classNames from "classnames";

const StatPriorities = ({ statPriorities, encounterType }) => {
  let statPriorityNumber = 1;
  const tooltipText =
    encounterType === "PvP"
      ? "Stat Priority is aggregated from the top PvPers in the Warcraft Armory API."
      : "Stat Priority is determined by aggregating the top player's stats on the Warcarft Logs raid or Mythic+ Rankings pages.";

  return (
    <div className="horizontal-list">
      <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE">
        <div className="label">
          <span>Stat Priority from Top Players</span>
          <TooltipContainer tooltipInfo={tooltipText}>
            <div className="question-mark">
              <TooltipIcon />
            </div>
          </TooltipContainer>
        </div>
      </MediaQuery>
      <div className="stat-list">
        {statPriorities.map((sp, index) => {
          const bg = statPrioColor(index);
          const isLast = index + 1 === statPriorities.length;
          const equals = sp.split("=");
          return (
            <React.Fragment key={index}>
              {equals.map((x, i) => {
                const lastEqual = i + 1 === equals.length;
                let longName = x;
                if (x === "crit") {
                  longName = "Critical Strike";
                }
                return (
                  <React.Fragment key={i}>
                    <div className="pill-box" style={{}}>
                      <span
                        className={classNames("pill-box-left", {
                          "high-prio": index === 0,
                        })}
                        style={{ background: bg.left }}
                      >
                        {statPriorityNumber++}
                      </span>
                      <span
                        className={classNames("pill-box-right", {
                          "high-prio": index === 0,
                        })}
                        style={{ background: bg.right }}
                      >
                        {capitalizeFirstLetter(x)}
                      </span>
                    </div>
                    {!lastEqual && (
                      <div className="chevron equals">
                        <ChevronLeft />
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
              {!isLast && (
                <div className="chevron">
                  <ChevronLeft />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StatPriorities;
